import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableRow, Table, TableHead
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const productData = this.props.productList;
        const searchData = this.props.searchData;
        const headCells = this.props.headCells;
        const factoryNameArray = this.props.factoryNameArray;
        
        const groupedData = productData.reduce((acc, item) => {
            if (!acc[item.productCategoryName]) {
                acc[item.productCategoryName] = [];
            }
            acc[item.productCategoryName].push(item);
            return acc;
        }, {});

        return (
            <div style={{ padding: '10px' }}>
                <h4>Date - {searchData.fromDate ? new Date(searchData.fromDate).toISOString().split('T')[0] : 'Date not available'}</h4>
                <h3><center><u>Price Comparison Report</u></center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <TableContainer>
                        <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                            <TableHead>
                                <TableRow>
                                    {headCells.map((headCell) => (
                                        <TableCell
                                            key={headCell.id}
                                            align={headCell.align}
                                            padding={headCell.disablePadding ? 'none' : 'default'}
                                            colSpan={headCell.colSpan || 1}
                                            rowSpan={headCell.rowSpan || 1}
                                            style={{
                                                border: "1px solid black",
                                                fontWeight: 'bold',
                                                ...headCell.style
                                            }}
                                        >
                                            {headCell.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    {headCells.map((headCell) =>
                                        headCell.id === 'cargillsPrices' ? (
                                            <React.Fragment key={headCell.id}>
                                                <TableCell align="right" style={{ border: "1px solid black", fontWeight: 'bold' } }>Buying Price</TableCell>
                                                <TableCell align="right" style={{ border: "1px solid black", fontWeight: 'bold' } }>Selling Price</TableCell>
                                            </React.Fragment>
                                        ) : null
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.keys(groupedData).map((productCategoryName, catIndex) => (
                                    <React.Fragment key={catIndex}>
                                        <TableRow>
                                            <TableCell colSpan={factoryNameArray.length + 5} align="left" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                {productCategoryName}
                                            </TableCell>
                                        </TableRow>
                                        {groupedData[productCategoryName].map((factory, index) => {
                                            const labelId = `enhanced-table-checkbox-${catIndex}-${index}`;
                                            
                                            return (
                                                <TableRow key={index} style={{ border: '1px solid black' }}>
                                                    <TableCell component="th" scope="row" align="Left" style={{ border: '1px solid black' }}>
                                                        {factory.productName}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ border: '1px solid black' }}>
                                                        {factory.volumeKG}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ border: '1px solid black' }}>
                                                        {factory.buyingPrice === undefined || factory.buyingPrice === 0 ? '-' : parseFloat(factory.buyingPrice).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ border: '1px solid black' }}>
                                                        {factory.sellingPrice === undefined || factory.sellingPrice === 0 ? '-' : parseFloat(factory.sellingPrice).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ border: '1px solid black' }}>
                                                        {factory.competitorPrice === undefined  || factory.competitorPrice === 0 ? '-' : parseFloat(factory.competitorPrice).toFixed(2)}
                                                    </TableCell>
                                                    {factoryNameArray.map((column, colIndex) => {
                                                        const value = factory[column.market];
                                                        return (
                                                            <TableCell key={colIndex} id={labelId} scope="row" align="right" style={{ border: '1px solid black' }}>
                                                                {value === undefined || value === 0 ? '-' : parseFloat(value).toFixed(2)}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </React.Fragment>
                                ))}
                                <TableRow>
                                    <TableCell component="th" scope="row" align="left" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                        Total
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                        {productData.reduce((acc, curr) => acc + (curr.volumeKG || 0), 0)}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                        {productData.reduce((acc, curr) => acc + (curr.buyingPrice || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                        {productData.reduce((acc, curr) => acc + (curr.sellingPrice || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                        {productData.reduce((acc, curr) => acc + (curr.competitorPrice || 0), 0).toFixed(2)}
                                    </TableCell>
                                    {factoryNameArray.map((column, colIndex) => (
                                        <TableCell key={colIndex} scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                            {productData.reduce((acc, curr) => acc + (curr[column.market] || 0), 0).toFixed(2)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}
